import {
    CREATE_PROPERTY_FAILURE,
    CREATE_PROPERTY_REQUEST,
    CREATE_PROPERTY_SUCCESS,
    CREATE_USER_FORM_PROPERTY,
    DELETE_PROPERTY_FAILURE,
    DELETE_PROPERTY_REQUEST,
    DELETE_PROPERTY_SUCCESS,
    FETCH_DROPDOWN_PROPERTY_FAILURE,
    FETCH_DROPDOWN_PROPERTY_REQUEST,
    FETCH_DROPDOWN_PROPERTY_SUCCESS,
    FETCH_PROPERTY_FAILURE,
    FETCH_PROPERTY_REQUEST,
    FETCH_PROPERTY_SUCCESS,
    FETCH_SINGLE_PROPERTY_FAILURE,
    FETCH_SINGLE_PROPERTY_REQUEST,
    FETCH_SINGLE_PROPERTY_SUCCESS,
    MAX_PROPERTY_SLNO_FAILURE,
    MAX_PROPERTY_SLNO_REQUEST,
    MAX_PROPERTY_SLNO_SUCCESS,
    PROPERTY_USERFORM_RESET,
    UPDATE_PROPERTY_FAILURE,
    UPDATE_PROPERTY_REQUEST,
    UPDATE_PROPERTY_SUCCESS
} from './property.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';

// FETCH PROPERTY
export let fetchProperty = () => {
    let config = {
        method: 'get',
        url: ConstantApi.propertyGET,
        responseTypeRequest: FETCH_PROPERTY_REQUEST,
        responseTypeSuccess: FETCH_PROPERTY_SUCCESS,
        responseTypeFailure: FETCH_PROPERTY_FAILURE
    };
    return axiosCall(config);
};

// FETCH DROPDOWN PROPERTY LIST
export let fetchDropdownProperty = () => {
    let config = {
        method: 'get',
        url: ConstantApi.propertyMasterListGET,
        responseTypeRequest: FETCH_DROPDOWN_PROPERTY_REQUEST,
        responseTypeSuccess: FETCH_DROPDOWN_PROPERTY_SUCCESS,
        responseTypeFailure: FETCH_DROPDOWN_PROPERTY_FAILURE
    };
    return axiosCall(config);
};

// CREATE PROPERTY
export let createProperty = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldFKProperty: parseInt(formData.propertySelect),
        fldSlNo: parseInt(formData.slno),
        fldDescription: formData.description,
        fldShortName: formData.sdescription,
        fldSetAsDefault: formData.check,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString()
    });
    // http://192.168.1.160/api/TblProperties/CreateTblProperties
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.propertyPOST}`,
        responseTypeRequest: CREATE_PROPERTY_REQUEST,
        responseTypeSuccess: CREATE_PROPERTY_SUCCESS,
        responseTypeFailure: CREATE_PROPERTY_FAILURE,
        resetFormData: PROPERTY_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchProperty(),
        singlApiArray: [createPropertyUserForm('slno', '')]
    };
    return axiosCall(config);
};

// GET get SLNO of that property
export let maxSlNoOfProperty = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${id}`,
        responseTypeRequest: MAX_PROPERTY_SLNO_REQUEST,
        responseTypeSuccess: MAX_PROPERTY_SLNO_SUCCESS,
        responseTypeFailure: MAX_PROPERTY_SLNO_FAILURE
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY
export let getSingleProperty = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.propertyGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_PROPERTY_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_PROPERTY_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_PROPERTY_FAILURE,
        singlApiArray: [fetchProperty()]
    };
    return axiosCall(config);
};

//UPDATE PROPERTY
export let updateProperty = (id, formData) => {
    let today = new Date();
    let data = {
        fldId: parseInt(id),
        fldFKProperty: parseInt(formData.propertySelect),
        fldSlNo: parseInt(formData.slno),
        fldDescription: formData.description,
        fldShortName: formData.sdescription,
        fldIsActive: true,
        fldSetAsDefault: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString()
        // fldDeletedBy: 1,
        // fldDeletedDt: '2022-04-22T00:00:00'
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.propertyPATCH}/${id}`,
        responseTypeRequest: UPDATE_PROPERTY_REQUEST,
        responseTypeSuccess: UPDATE_PROPERTY_SUCCESS,
        responseTypeFailure: UPDATE_PROPERTY_FAILURE,
        resetFormData: PROPERTY_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchProperty()
    };
    return axiosCall(config);
};

// DELETE PROPERTY
export let deleteProperty = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.propertyDELETE}/${id}`,
        responseTypeRequest: DELETE_PROPERTY_REQUEST,
        responseTypeSuccess: DELETE_PROPERTY_SUCCESS,
        responseTypeFailure: DELETE_PROPERTY_FAILURE,
        resetFormData: PROPERTY_USERFORM_RESET,
        modalClose: true,
        getAllData: fetchProperty()
    };
    return axiosCall(config);
};

export let createPropertyUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_PROPERTY, payload: { key, value } });
    };
};
